"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const core_1 = require("@material-ui/core");
require("./app.scss");
const billingHistory_1 = __importDefault(require("./components/billingHistory/billingHistory"));
const plans_1 = __importDefault(require("./components/plans/plans"));
const subscriptionSlice_1 = require("../../redux/slices/subscriptionSlice");
const common_1 = require("../../utils/common");
const userSlice_1 = require("../../redux/slices/userSlice");
const successfully_1 = __importDefault(require("./components/successfullyModal/successfully"));
const subscribeModal_1 = __importDefault(require("./components/subscribeModal/subscribeModal"));
const infoModal_1 = __importDefault(require("../../shared/components/modals/infoModal/infoModal"));
class App extends react_1.Component {
    constructor() {
        super(...arguments);
        this.state = {
            blockOnMobile: common_1.ifMobile()
        };
    }
    componentDidMount() {
        if (common_1.ifMobile()) {
            return this.props.toggleMobileInfoModal(true);
        }
        this.props.getSubscription();
        setTimeout(() => {
            this.props.getUser();
            this.props.getUpcomingCharge();
        }, 300);
        this.props.getLawFirmData();
    }
    render() {
        const { subscription, toggleModal, modalTitle, toggleSubModal, subscribe, user, trial, toggleMobileModal } = this.props;
        const { blockOnMobile } = this.state;
        return (react_1.default.createElement(react_1.Fragment, null,
            !blockOnMobile && react_1.default.createElement("h3", { className: 'page-title mb-30' }, "Subscription"),
            react_1.default.createElement(core_1.Grid, { container: true, direction: "row", justify: "center", alignItems: "center" }, !blockOnMobile && react_1.default.createElement(react_1.Fragment, null,
                react_1.default.createElement(plans_1.default, { subscriptionData: subscription, userData: user }),
                react_1.default.createElement(billingHistory_1.default, null))),
            toggleModal && react_1.default.createElement(successfully_1.default, { open: toggleModal, title: 'Success', description: modalTitle, cancelable: () => this.props.toggleSuccessModal('') }),
            toggleSubModal && react_1.default.createElement(subscribeModal_1.default, { open: toggleSubModal, subscriptionData: subscription, title: 'Subscription', cancelable: () => this.props.toggleSubscribeModal(), handleClick: (trial) => subscribe(trial), trial: trial }),
            toggleMobileModal && react_1.default.createElement(infoModal_1.default, { open: toggleMobileModal, description: 'You can manage your subscription for a Desktop computer only.', cancelable: () => {
                    this.props.toggleMobileInfoModal();
                    window.location.href = '#/';
                    common_1.goExternalUrl("https://app.appearme.com/#/subscription");
                } })));
    }
}
const mapStateToProps = (state) => {
    const { subscription, user } = state;
    return {
        subscription: subscription.subscription,
        toggleModal: subscription.toggleModal,
        toggleSubModal: subscription.toggleSubModal,
        toggleMobileModal: subscription.toggleMobileModal,
        modalTitle: subscription.modalTitle,
        trial: subscription.trial,
        user
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getSubscription: () => dispatch(subscriptionSlice_1.getSubscription()),
        toggleSuccessModal: (data) => dispatch(subscriptionSlice_1.toggleSuccessModal(data)),
        toggleSubscribeModal: (trial) => dispatch(subscriptionSlice_1.toggleSubscribeModal(trial)),
        toggleMobileInfoModal: (data) => dispatch(subscriptionSlice_1.toggleMobileInfoModal(data)),
        subscribe: (trial) => dispatch(subscriptionSlice_1.subscribe(trial)),
        getUser: () => dispatch(userSlice_1.getUser()),
        getLawFirmData: () => dispatch(subscriptionSlice_1.getLawFirmData()),
        getUpcomingCharge: () => dispatch(subscriptionSlice_1.getUpcomingCharge())
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(App);
